module.exports = __webpack_public_path__ + "assets/CategoryProportion.dddb32c8.svg";